import React from "react";
import { useEffect, useState } from "react";
import { FiArrowUpRight, FiExternalLink, FiDownload } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

import { FaReact, FaAngular, FaVuejs, FaNodeJs, FaPython, FaJava, FaDatabase, FaBootstrap, FaGithub } from "react-icons/fa";
import { SiNextdotjs, SiJavascript, SiTypescript, SiRedux, SiTailwindcss, SiCss3, SiHtml5, SiFlutter, SiDart, SiMongodb, SiMysql, SiFigma } from "react-icons/si";
import Profile from './Profile';

// Project Imports
import ccb from '../Assets/CCB.png'
import buzz from '../Assets/buzz.png'
import onemind from '../Assets/one.png'
import kalam from '../Assets/kalamkids.png'
import green from '../Assets/Greenarcade.png'
import rds from '../Assets/rds.png'
import jjj from '../Assets/jjj.png'
import adv from '../Assets/adv.png'
import genie from '../Assets/ourgenieapp.in_.png'
import nxtera from "../Assets/nxtera.png"
import rs from "../Assets/rs.png"
import work from "../Assets/hapee group.png"
import  royal from "../Assets/royalEnfeild.png"

import emailjs from 'emailjs-com';
import Navbar from "./Navbar";

const tools = [
  { name: "ReactJS", icon: <FaReact className="text-blue-500 w-8 h-8" /> },
  { name: "Next.js", icon: <SiNextdotjs className="text-gray-500 w-8 h-8" /> },
  { name: "Angular", icon: <FaAngular className="text-red-500 w-8 h-8" /> },
  { name: "JavaScript", icon: <SiJavascript className="text-yellow-500 w-8 h-8" /> },
  { name: "TypeScript", icon: <SiTypescript className="text-blue-600 w-8 h-8" /> },
  { name: "Redux", icon: <SiRedux className="text-purple-500 w-8 h-8" /> },
  { name: "Vue.js", icon: <FaVuejs className="text-green-500 w-8 h-8" /> },
  { name: "Bootstrap", icon: <FaBootstrap className="text-indigo-500 w-8 h-8" /> },
  { name: "Tailwind CSS", icon: <SiTailwindcss className="text-blue-400 w-8 h-8" /> },
  { name: "CSS", icon: <SiCss3 className="text-blue-600 w-8 h-8" /> },
  { name: "HTML", icon: <SiHtml5 className="text-orange-500 w-8 h-8" /> },
  { name: "Node.js", icon: <FaNodeJs className="text-green-600 w-8 h-8" /> },
  { name: "Python", icon: <FaPython className="text-yellow-400 w-8 h-8" /> },
  { name: "Java", icon: <FaJava className="text-red-600 w-8 h-8" /> },
  { name: "Flutter", icon: <SiFlutter className="text-blue-500 w-8 h-8" /> },
  { name: "Dart", icon: <SiDart className="text-blue-600 w-8 h-8" /> },
  { name: "MongoDB", icon: <SiMongodb className="text-green-500 w-8 h-8" /> },
  { name: "MySQL", icon: <SiMysql className="text-blue-400 w-8 h-8" /> },
  { name: "Figma", icon: <SiFigma className="text-pink-500 w-8 h-8" /> },
  { name: "GitHub", icon: <FaGithub className="text-gray-400 w-8 h-8" /> },
];

const projects = [
  {
    title: 'Chitra Coffee Bar Auditor (product)',
    description:
      'A Tea Shop Auditor web application for managing audits, tracking shop status, reviewing compliance, and ensuring quality standards efficiently.',
    img: ccb,
    link: 'https://auditor.chitracoffeebar.com/',
    category: 'Enterprise',
    tech: ['React', 'Node.js', 'MySQL']
  },
{
  title: 'Workforce Management (Product)',
  description:
    'A workforce management system designed to handle employee attendance, shift scheduling, performance tracking, and payroll integration, helping organizations streamline operations and improve productivity.',
  img: work,
  link: 'https://admin.happeegroup.com/login',
  category: 'Business',
  tech: ['React', 'Express', 'MongoDB']
},
  {
    title: 'Uniform Management (product)',
    description:
      'A Uniform Management web application for tracking inventory, assigning uniforms, managing orders, and ensuring efficient distribution across organizations.',
    img: buzz,
    link: 'https://manage.buzzuniforms.com/',
    category: 'Business',
    tech: ['React', 'Express', 'MongoDB']
  },
  {
    title: 'Our Genie App',
    description:
      'Smart House Cleaning Services that bring comfort and care to your doorstep.',
    img: genie,
    link: 'https://ourgenieapp.in/',
    category: 'Service',
    tech: ['React', 'Next.js', 'Node.js']
  },
{
  title: 'Royal Enfield ',
  description:
    'A modern, responsive website developed to showcase brand identity, products, and digital presence. Focused on clean UI/UX, performance optimization, and SEO-friendly architecture.',
  img: royal,
  link: 'https://kalikambal.skishore.in/',
  category: 'Service',
  tech: ['Next.js', 'Tailwind', 'SEO']
},
  {
    title: 'Nxtera Digital',
    description:
      'Elevate your brand with strategic, data-driven marketing solutions. Nxtera Digital helps businesses grow through measurable digital strategies and impactful online presence.',
    img: nxtera,
    link: 'https://nxteradigital.com/',
    category: 'Agency',
    tech: ['Next.js', 'Tailwind', 'SEO']
  },
  {
    title: 'Kalam Kids',
    description: 'A platform for kindergarten education and resources.',
    img: kalam,
    link: 'https://kalamkids.in/',
    category: 'Education',
    tech: ['React', 'Node.js']
  },
  {
    title: 'Green Arcade',
    description:
      'A construction company specializing in innovative building solutions.',
    img: green,
    link: 'https://greenarcade.in/',
    category: 'Construction',
    tech: ['React', 'Bootstrap']
  },
  {
    title: 'RS Collaborate Solutions',
    description:
      'Helping businesses reach sustainable growth through expert consulting, strategic planning, and tailored business solutions.',
    img: rs,
    link: 'https://rscollaboratessolutions.com/',
    category: 'Consulting',
    tech: ['React', 'Express']
  },
  {
    title: 'Charethri Business Solutions',
    description:
      'A platform for legal and advocacy services.',
    img: adv,
    link: 'https://charethribs.com/',
    category: 'Legal',
    tech: ['React', 'Node.js']
  },
];

 
const exp = [
  {
    title: "Web Developer – GSK Consultants",
    description:
      "Developed responsive web applications using React.js, Node.js, and PHP. Built RESTful APIs and managed MySQL/MongoDB databases for scalable data flow. Deployed applications using Azure and Hostinger with CI/CD pipelines ensuring 99.9% uptime. Managed SEO optimization and Meta Ads campaigns, increasing website traffic by 35%.",
    start: "November 2025",
    end: "Present",
  },
  {
    title: "Web Developer – Green Emerald Agency",
    description:
      "Designed and developed reusable UI components using React.js and Vue.js, improving code efficiency by 25%. Implemented backend integrations with Node.js, Express, and MongoDB. Optimized UI using Tailwind CSS and responsive layouts to enhance user engagement. Documented workflows and analysis for team reference.",
    start: "December 2024",
    end: "August 2025",
  },
  {
    title: "Junior Full Stack Developer – KNACK BAY Technologies Pvt Ltd",
    description:
      "Built cross-device responsive layouts using Tailwind CSS, Flexbox, and CSS Grid. Developed and maintained RESTful APIs with real-time data synchronization and low latency. Conducted end-to-end testing using Jest and Cypress to improve application reliability and performance.",
    start: "September 2023",
    end: "December 2024",
  },
];

const Counter = ({ target, label }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = target;
    if (start === end) return;

    let totalMilSecDur = 100;
    let incrementTime = (totalMilSecDur / end) * 10;

    let timer = setInterval(() => {
      start += 1;
      setCount(start);
      if (start === end) clearInterval(timer);
    }, incrementTime);

    return () => clearInterval(timer);
  }, [target]);

  return (
    <div className="transform hover:scale-105 transition-transform">
      <h2 className="text-4xl sm:text-5xl md:text-7xl font-bold text-[#914EEE]">{count}+</h2>
      <p className="text-gray-400 text-xs sm:text-sm font-medium">{label}</p>
    </div>
  );
};

const Home = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [showDialog, setShowDialog] = useState(false);
  const [activeFilter, setActiveFilter] = useState('all');

  const templateParams = {
    name: formData.name,
    time: new Date().toLocaleString(),
    message: formData.message,
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.send('service_150viqm', 'template_k60uang', templateParams, 'C8FtLDGyCMS1376Vu')
      .then((response) => {
        console.log('Email sent successfully!', response.status, response.text);
        setFormData({ name: '', email: '', message: '' });
        setShowDialog(true);
        setTimeout(() => setShowDialog(false), 3000);
      }, (error) => {
        console.error('Failed to send email:', error);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const navigate = useNavigate();

  // Filter projects
  const categories = ['all', ...new Set(projects.map(p => p.category))];
  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(p => p.category === activeFilter);

  return (
    <div className="bg-gradient-to-br from-[#0a0a0a] via-[#121212] to-[#1a1a1a] text-white w-full py-5 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Animated background elements */}
      <div className="fixed inset-0 opacity-30 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#914EEE] rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse" style={{animationDelay: '2s'}}></div>
      </div>

      <Navbar />

      <div className="flex flex-col md:flex-row relative z-10">
        <div className="w-full md:w-[40%] lg:w-[40%] xl:w-[40%]">
          <Profile />
        </div>

        {/* Content Section */}
        <div className="w-full md:w-[60%] lg:w-[60%] xl:w-[60%] my-4 md:my-9 space-y-8 md:space-y-16">
          
          {/* Hero Section */}
          <div className="px-2 md:px-0 space-y-6">
            <div className="inline-block">
              <span className="text-xs md:text-sm font-semibold text-[#914EEE] bg-[#914EEE]/10 px-4 py-2 rounded-full">
                 Full Stack Developer
              </span>
            </div>
            
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-extrabold tracking-tight leading-tight">
              <span className="text-white">SOFTWARE</span>
              <br />
              <span className="bg-gradient-to-r from-[#914EEE] to-blue-500 bg-clip-text text-transparent">DEVELOPER</span>
            </h1>

            <p className="text-gray-400 text-sm sm:text-base max-w-2xl leading-relaxed">
              I build <span className="text-[#914EEE]">high-performance web applications</span> using React, Node.js, and modern tech stacks. 
              Specialized in <span className="text-[#914EEE]">UI/UX design</span>, <span className="text-[#914EEE]">SEO optimization</span>, 
              and <span className="text-[#914EEE]">digital growth strategies</span>.
            </p>

            {/* Stats */}
            <div className="flex flex-col sm:flex-row gap-8 mt-8 flex-wrap">
              <Counter target={3} label="Years of Experience" />
              <Counter target={35} label="Projects Completed" />
              <div className="transform hover:scale-105 transition-transform">
                <h2 className="text-4xl sm:text-5xl md:text-7xl font-bold text-[#914EEE]">100%</h2>
                <p className="text-gray-400 text-xs sm:text-sm font-medium">Client Satisfaction</p>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button
                onClick={() => navigate("/pricing")}
                className="group inline-flex items-center gap-2 bg-gradient-to-r from-[#914EEE] to-purple-600 text-white font-semibold px-6 py-3 rounded-lg hover:shadow-lg hover:shadow-[#914EEE]/50 transition-all duration-300"
              >
                View Packages
                <FiArrowUpRight className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
              </button>
              <button
                onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                className="border-2 border-[#914EEE] text-[#914EEE] font-semibold px-6 py-3 rounded-lg hover:bg-[#914EEE]/10 transition-all duration-300"
              >
                Get In Touch
              </button>
            </div>
          </div>

          {/* Apps & Software Landing Pages Section */}
          <div id="apps" className="mt-16 md:mt-32 px-2 md:px-0 space-y-10">

            {/* CTA for Apps */}
            <div className="bg-gradient-to-r from-[#914EEE]/10 to-blue-500/10 border border-[#914EEE]/30 p-8 rounded-xl text-center space-y-4 mt-8">
              <h3 className="text-2xl md:text-3xl font-bold">Need a Custom App?</h3>
              <p className="text-gray-400 max-w-xl mx-auto">
                I can build scalable, user-friendly apps tailored to your business needs
              </p>
              <button
                onClick={() => navigate("/pricing")}
                className="inline-flex items-center gap-2 bg-[#914EEE] text-white font-semibold px-6 py-3 rounded-lg hover:bg-[#7A3ECC] transition-all duration-300"
              >
                Request a Quote
                <FiArrowUpRight />
              </button>
            </div>
          </div>

          {/* Recent Projects Section */}
          <div id="projects" className="mt-16 md:mt-32 px-2 md:px-0 space-y-10">
            <div className="space-y-2">
              {/* <div className="inline-block">
                <span className="text-xs md:text-sm font-semibold text-[#914EEE] bg-[#914EEE]/10 px-4 py-2 rounded-full">
                  🎯 PORTFOLIO
                </span>
              </div> */}
              <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold leading-tight">
                RECENT
                <br />
                <span className="text-[#353334]">PROJECTS</span>
              </h1>
            </div>

            {/* Filter Buttons */}
            <div className="flex flex-wrap gap-2 md:gap-3">
              {categories.map(cat => (
                <button
                  key={cat}
                  onClick={() => setActiveFilter(cat)}
                  className={`px-4 py-2 rounded-lg font-semibold text-sm transition-all duration-300 ${
                    activeFilter === cat
                      ? 'bg-[#914EEE] text-white'
                      : 'bg-[#1A1A1A] text-gray-400 hover:text-white border border-gray-700'
                  }`}
                >
                  {cat.charAt(0).toUpperCase() + cat.slice(1)}
                </button>
              ))}
            </div>

            {/* Projects Grid */}
            <div className="space-y-4 md:space-y-6">
              {filteredProjects.map((project, index) => (
                <a
                  key={index}
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex flex-col sm:flex-row items-start sm:items-center bg-[#1A1A1A]/80 backdrop-blur border border-gray-700 p-4 sm:p-6 rounded-xl md:rounded-2xl hover:border-[#914EEE]/50 hover:bg-[#1A1A1A] transition-all duration-300 hover:shadow-lg hover:shadow-[#914EEE]/10"
                >
                  <img
                    src={project.img}
                    alt={project.title}
                    className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 object-cover rounded-lg sm:rounded-xl mr-4 sm:mr-6 mb-4 sm:mb-0 border-2 border-[#914EEE] group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <h2 className="text-lg sm:text-xl md:text-2xl font-semibold tracking-wide text-white">
                        {project.title}
                      </h2>
                      <span className="text-xs bg-[#914EEE]/20 text-[#914EEE] px-2 py-1 rounded">
                        {project.category}
                      </span>
                    </div>
                    <p className="text-gray-400 text-xs sm:text-sm md:text-base leading-relaxed mb-2">
                      {project.description}
                    </p>
                    <div className="flex flex-wrap gap-2">
                      {project.tech.map((t, i) => (
                        <span key={i} className="text-xs text-gray-500 bg-gray-800/50 px-2 py-1 rounded">
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>
                  <FiArrowUpRight className="text-[#914EEE] text-2xl sm:text-3xl mt-4 sm:mt-0 ml-auto sm:ml-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                </a>
              ))}
            </div>
          </div>

          {/* Experience Section */}
          <div id="experience" className="mt-16 md:mt-32 px-2 md:px-0 space-y-10">
            <div className="space-y-2">
              <div className="inline-block">
                <span className="text-xs md:text-sm font-semibold text-[#914EEE] bg-[#914EEE]/10 px-4 py-2 rounded-full">
                  💼 CAREER PATH
                </span>
              </div>
              <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold leading-tight">
                3 YEARS OF
                <br />
                <span className="text-[#353334]">EXPERIENCE</span>
              </h1>
            </div>

            <div className="space-y-4 md:space-y-6">
              {exp.map((experience, index) => (
                <div
                  key={index}
                  className="bg-[#1A1A1A]/80 backdrop-blur border border-gray-700 p-4 sm:p-6 rounded-xl md:rounded-2xl hover:border-[#914EEE]/50 transition-all duration-300 hover:shadow-lg hover:shadow-[#914EEE]/10"
                >
                  <div className="flex items-start justify-between mb-2">
                    <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-white">
                      {experience.title}
                    </h2>
                    <div className="text-right text-xs md:text-sm text-gray-400">
                      <p>{experience.start} - {experience.end}</p>
                    </div>
                  </div>
                  <p className="text-gray-400 text-xs sm:text-sm md:text-base leading-relaxed">
                    {experience.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Skills Section */}
          <div id="skills" className="mt-16 md:mt-32 px-2 md:px-0 space-y-10">
            <div className="space-y-2">
              <div className="inline-block">
                <span className="text-xs md:text-sm font-semibold text-[#914EEE] bg-[#914EEE]/10 px-4 py-2 rounded-full">
                  🛠️ EXPERTISE
                </span>
              </div>
              <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold leading-tight">
                PREMIUM
                <br />
                <span className="text-[#353334]">SKILLS</span>
              </h1>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {tools.map((tool, index) => (
                <div
                  key={index}
                  className="group flex flex-col items-center bg-[#1A1A1A]/80 backdrop-blur border border-gray-700 p-4 rounded-lg hover:border-[#914EEE]/50 transition-all duration-300 hover:shadow-lg hover:shadow-[#914EEE]/10 hover:-translate-y-1"
                >
                  <div className="group-hover:scale-125 transition-transform duration-300">
                    {tool.icon}
                  </div>
                  <span className="text-gray-400 text-sm font-medium mt-2 text-center group-hover:text-[#914EEE] transition-colors">
                    {tool.name}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Contact Section */}
          <div id="contact" className="mt-16 md:mt-32 px-2 md:px-0 space-y-10">
            <div className="space-y-2">
              <div className="inline-block">
                <span className="text-xs md:text-sm font-semibold text-[#914EEE] bg-[#914EEE]/10 px-4 py-2 rounded-full">
                  📧 LET'S CONNECT
                </span>
              </div>
              <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold leading-tight">
                LET'S WORK
                <br />
                <span className="text-[#353334]">TOGETHER</span>
              </h1>
            </div>

            <form className="space-y-4 md:space-y-6 max-w-2xl" onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                <div>
                  <label className="block text-gray-300 text-sm md:text-base mb-2 font-semibold">
                    Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full p-3 md:p-4 bg-[#1A1A1A] text-white border border-gray-700 rounded-lg outline-none focus:border-[#914EEE] transition-colors text-sm md:text-base placeholder-gray-500"
                    placeholder="Enter your name"
                    required
                  />
                </div>
                <div>
                  <label className="block text-gray-300 text-sm md:text-base mb-2 font-semibold">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full p-3 md:p-4 bg-[#1A1A1A] text-white border border-gray-700 rounded-lg outline-none focus:border-[#914EEE] transition-colors text-sm md:text-base placeholder-gray-500"
                    placeholder="Enter your email"
                    required
                  />
                </div>
              </div>
              <div>
                <label className="block text-gray-300 text-sm md:text-base mb-2 font-semibold">
                  Message
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full p-3 md:p-4 bg-[#1A1A1A] text-white border border-gray-700 rounded-lg outline-none focus:border-[#914EEE] transition-colors text-sm md:text-base placeholder-gray-500"
                  placeholder="Tell me about your project..."
                  rows="5"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-[#914EEE] to-purple-600 text-white p-3 md:p-4 rounded-lg hover:shadow-lg hover:shadow-[#914EEE]/50 transition-all duration-300 font-semibold text-sm md:text-base group flex items-center justify-center gap-2"
              >
                Send Message
                <FiArrowUpRight className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
              </button>
            </form>
          </div>

          {showDialog && (
            <div className="fixed inset-0 flex items-center justify-center bg-black/70 backdrop-blur z-50 p-4">
              <div className="bg-[#1A1A1A] border border-[#914EEE]/50 text-white p-6 md:p-8 rounded-xl shadow-lg space-y-4 max-w-sm w-full animate-in">
                <div className="text-4xl">✨</div>
                <h2 className="text-2xl font-bold">Thank You!</h2>
                <p className="text-gray-400">
                  Your message has been sent successfully. I'll get back to you soon!
                </p>
              </div>
            </div>
          )}

          {/* Footer */}
          <div className="border-t border-gray-700 mt-16 md:mt-32 pt-8 md:pt-12 text-center space-y-6">
            <a
              href="https://github.com/Kishore174"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#914EEE] hover:text-white transition-colors font-semibold group"
            >
              <FaGithub className="w-5 h-5 md:w-6 md:h-6 group-hover:scale-125 transition-transform" />
              <span>Check out my GitHub</span>
              <FiExternalLink className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
            <p className="text-gray-500 text-xs md:text-sm">
              © 2025 Kishore S. All rights reserved. Built with React & Tailwind CSS.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;